module.exports = __webpack_public_path__ + "c370a20a640a9734c31a38a970690903.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/projekte/theater-2016.jpg
// module id = 537
// module chunks = 0